module.exports = __webpack_public_path__ + "static/media/zitsafund.3a74582a.png";